import { Loading } from "@ebsco-ui/ebsco-ui";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { compose } from "redux";
import sharedMessages from "../../../../shared-messages";
import getIsCoppa from "../../../store/coppa";
import { navigateToMyAccountPage } from "../../../store/navigation/navigation";
import ReturnLink from "../../return-link/return-link";
import withGdprResponseData from "../../with-gdpr-response-data";
import withPersonalization from "../../with-personalization";
import AccountRemovalWithFlagOn from "../account-removal/account-removal-with-flag-on";
import AccountRemovedIndicator from "../account-removed-indicator";
import ConsentDateNotificationWithFlagOn from "../consent-date-notification/consent-date-notification-with-flag-on";
import MyEbscoDataPrivacy from "../my-ebsco-data-privacy/my-ebsco-data-privacy";
import MyEbscoDataReporting from "../my-ebsco-data-reporting";
import PersonalDataSettingsWithFlagOn from "../personal-data-settings/personal-data-settings-with-flagon";
import DataRetentionPageWithFlagOn from "./data-retention-page-with-flag-on";
import "./data-retention-page.scss";

const DataRetentionPage = ({
  isCoppa,
  queryString,
  navigateToMyAccount,
  forgetUserSuccess,
  isLoading,
  intl: { formatMessage }
}) => {
  const myAccountPageUrl = `/user${queryString}`;
  const handleNavigateToMyAccountPageClick = () => {
    navigateToMyAccount(myAccountPageUrl);
  };

  const displayDataRetentionPageTitle = () => {
    return isCoppa ? (
      <FormattedMessage {...sharedMessages.dataRetentionAndUsage} />
    ) : (
      <FormattedMessage {...sharedMessages.personalDataRetentionAndUsage} />
    );
  };

  const displayCoppaAccount = () => {
    return (
      <>
        <MyEbscoDataPrivacy isCoppa={isCoppa} />
        <MyEbscoDataReporting />
        <AccountRemovalWithFlagOn />
      </>
    );
  };

  const displayNonCoppaAccount = () => {
    return (
      <>
        <MyEbscoDataPrivacy isCoppa={isCoppa} />
        <ConsentDateNotificationWithFlagOn />
        <PersonalDataSettingsWithFlagOn />
      </>
    );
  };

  const displayAccountDataInfo = () => {
    return isCoppa ? displayCoppaAccount() : displayNonCoppaAccount();
  };

  const componentToRender = (
    <main className="data-retention-page">
      <ReturnLink
        isExternalLink={false}
        url={myAccountPageUrl}
        onClick={handleNavigateToMyAccountPageClick}
      >
        <FormattedMessage {...sharedMessages.backToMyAccount} />
      </ReturnLink>
      <DataRetentionPageWithFlagOn
        displayAccountDataInfo={displayAccountDataInfo}
        displayDataRetentionPageTitle={displayDataRetentionPageTitle}
        isCoppa={isCoppa}
      />
    </main>
  );

  if (isLoading)
    return <Loading loadingMessage={formatMessage(sharedMessages.loading)} />;
  return forgetUserSuccess ? (
    <main className="forget-success">
      <AccountRemovedIndicator />
    </main>
  ) : (
    componentToRender
  );
};

DataRetentionPage.propTypes = {
  navigateToMyAccount: PropTypes.func.isRequired,
  forgetUserSuccess: PropTypes.bool.isRequired,
  queryString: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  queryString: state.router.location.search,
  forgetUserSuccess: state.gdpr.accountRemoval.forgetUserSuccess,
  isCoppa: getIsCoppa(state),
  isLoading: state.consentDateTime.loading
});

const mapDispatchToProps = {
  navigateToMyAccount: navigateToMyAccountPage
};

export { DataRetentionPage };
export default compose(
  withPersonalization,
  withGdprResponseData,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(DataRetentionPage);
